/* Yarnstore Set-Konfigurator, Stand 3. Fassung (28.09.2026): Fehlerpfade nach Codex-Nachpruefung geklaert
   (unbekannter Ausgang wird per Vorgangskennung abgeglichen, Ruecknahme wird im Warenkorb nachgeprueft).
   Liest die Auswahl aus dem Baustein yf-strickset.liquid, rechnet Bedarf je Garnvariante ueber
   alle Farbplaetze zusammen, gleicht mit dem Bestand und dem vorhandenen Warenkorb ab, sperrt
   waehrend einer Anfrage, prueft nach dem Hinzufuegen den tatsaechlichen Warenkorb und entfernt
   unvollstaendige Sets wieder. Legt nur Garnvarianten und die Anleitung als normale Zeilen ab,
   niemals das Traeger-Produkt. Regeln: Brain, wiki/themen/prozess-stricksets.md */
(function () {
  function money(c) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format((c || 0) / 100);
  }
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('Warenkorb HTTP ' + r.status);
      return r.json();
    });
  }
  function warte(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }
  /* Nur lesend wiederholen, nie schreibend. */
  function leseKorb(versuche) {
    return fetchCart().catch(function (e) {
      if (versuche <= 1) throw e;
      return warte(1200).then(function () { return leseKorb(versuche - 1); });
    });
  }
  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }
  function el(root, s) { return root.querySelector(s); }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var groessen;
    try { groessen = JSON.parse(el(root, '[data-yf-groessen]').textContent || '[]'); } catch (e) { groessen = []; }
    var slots = [].slice.call(root.querySelectorAll('[data-yf-slot]'));
    var anl = el(root, '[data-yf-anleitung]');
    var addBtn = el(root, '[data-yf-add]');
    var probEl = el(root, '[data-yf-problems]');
    var doneEl = el(root, '[data-yf-done]');
    var configError = !!el(root, '[data-yf-config-error]');
    var st = { size: 0, qty: 1, busy: false, cart: {}, offen: null, meldungen: [] };

    function sel(slot) { return slot.querySelector('.yf-set__swatch.is-selected'); }
    function mengen() { var g = groessen[st.size] || {}; return g.mengen || []; }
    function sizeName() { var g = groessen[st.size] || {}; return g.groesse || ''; }

    /* Bedarf je Garnvariante ueber alle Farbplaetze, plus Liste der Probleme. */
    function bedarf() {
      var m = mengen(), byId = {}, order = [], probleme = [];
      slots.forEach(function (slot, i) {
        var s = sel(slot), n = m[i] || 0, platz = slot.dataset.platz;
        if (!n) { probleme.push(platz + ': für diese Größe ist keine Knäuelzahl hinterlegt.'); return; }
        if (!s) { probleme.push(platz + ': bitte eine Farbe wählen.'); return; }
        var id = s.dataset.id;
        if (!byId[id]) {
          byId[id] = { id: id, n: 0, title: s.dataset.title, garn: slot.dataset.garn, price: +s.dataset.price,
            inv: +s.dataset.inventory, tracked: s.dataset.tracked === 'true', policy: s.dataset.policy,
            available: s.dataset.available === 'true', teile: [], slots: [] };
          order.push(id);
        }
        byId[id].n += n; byId[id].teile.push(platz); byId[id].slots.push(slot);
      });
      return { byId: byId, order: order, probleme: probleme };
    }

    function render() {
      var m = mengen(), b = bedarf(), perSet = 0, lines = [], probleme = b.probleme.slice();
      slots.forEach(function (slot, i) {
        var s = sel(slot), n = m[i] || 0;
        el(slot, '[data-yf-slot-name]').textContent = s ? s.dataset.title : 'bitte wählen';
        el(slot, '[data-yf-slot-info]').textContent = (s && n) ? n + ' × ' + money(+s.dataset.price) : '';
        var stEl = el(slot, '[data-yf-slot-stock]'); stEl.textContent = ''; stEl.className = 'yf-set__stock';
      });
      b.order.forEach(function (id) {
        var v = b.byId[id], gesamt = v.n * st.qty;
        perSet += v.price * v.n;
        lines.push(gesamt + ' × ' + v.garn + ', ' + v.title + ' (' + v.teile.join(' und ') + '): ' + money(v.price * gesamt));
        var text = '', bad = false;
        if (!v.available) { text = 'Diese Farbe ist ausverkauft.'; bad = true; probleme.push(v.garn + ' ' + v.title + ' ist ausverkauft.'); }
        else if (v.tracked && v.policy === 'deny') {
          var imKorb = st.cart[id] || 0, frei = Math.max(0, v.inv - imKorb), sets = Math.floor(frei / v.n);
          text = (sets > 200 ? 'Über 200' : sets) + ' Set' + (sets === 1 ? '' : 's') + ' in dieser Farbe lieferbar';
          if (v.teile.length > 1) text += ' (' + v.n + ' Knäuel je Set, weil die Farbe auf ' + v.teile.length + ' Plätzen liegt)';
          if (imKorb) text += ', ' + imKorb + ' Knäuel liegen schon in deinem Warenkorb';
          text += '.';
          if (sets < st.qty) { bad = true; probleme.push(v.garn + ' ' + v.title + ': für ' + st.qty + ' Set' + (st.qty === 1 ? '' : 's') + ' fehlen ' + (gesamt - frei) + ' Knäuel.'); }
        }
        v.slots.forEach(function (slot) { var e = el(slot, '[data-yf-slot-stock]'); e.textContent = text; e.className = 'yf-set__stock' + (bad ? ' is-bad' : ''); });
      });
      var grand = perSet * st.qty;
      if (anl && anl.checked) {
        if (anl.dataset.available !== 'true') { probleme.push('Die Anleitung ist derzeit nicht verfügbar. Nimm das Häkchen weg oder komm später wieder.'); }
        else { grand += +anl.dataset.price; lines.push('1 × Anleitung ' + anl.dataset.title + ' als PDF' + (st.qty > 1 ? ' (wird auch bei ' + st.qty + ' Sets nur einmal berechnet)' : '') + ': ' + money(+anl.dataset.price)); }
      }
      if (configError) probleme.unshift('Dieses Set ist noch nicht vollständig eingerichtet. Bitte melde dich bei uns.');
      /* Fehlt noch eine Farbe, keine Teilsumme zeigen, sondern einen Hinweis (Claudia, 30.09.2026). */
      var farbeFehlt = slots.some(function (slot) { return !sel(slot); });
      var totalEl = el(root, '[data-yf-total]');
      totalEl.textContent = farbeFehlt ? 'Bitte erst alle Farben wählen' : money(grand);
      totalEl.classList.toggle('is-offen', farbeFehlt);
      el(root, '[data-yf-qty-value]').textContent = st.qty;
      var ul = el(root, '[data-yf-lines]'); ul.innerHTML = '';
      lines.forEach(function (t) { var li = document.createElement('li'); li.textContent = t; ul.appendChild(li); });
      probEl.innerHTML = '';
      /* Meldungen aus dem letzten Hinzufuegen bleiben stehen, bis die Kundin etwas aendert; sie sperren den Knopf nicht. */
      probleme.concat(st.meldungen).forEach(function (t) { var li = document.createElement('li'); li.textContent = t; probEl.appendChild(li); });
      probEl.hidden = probleme.length + st.meldungen.length === 0;
      addBtn.disabled = st.busy || probleme.length > 0;
      addBtn.textContent = st.busy ? 'Wird hinzugefügt …' : 'In den Warenkorb';
      return probleme.length === 0;
    }

    function merkeKorb(c) {
      st.cart = {};
      (c.items || []).forEach(function (i) { st.cart[i.variant_id] = (st.cart[i.variant_id] || 0) + i.quantity; });
      return c;
    }
    /* Fuer die Anzeige: Fehler werden geschluckt. Vor dem Hinzufuegen wird stattdessen leseKorb() verlangt. */
    function refreshCart() {
      return fetchCart().then(merkeKorb).catch(function () { return null; });
    }

    root.addEventListener('click', function (e) {
      if (st.busy) { e.preventDefault(); return; }
      var b = e.target.closest('[data-yf-size]');
      if (b && b.tagName === 'BUTTON') {
        root.querySelectorAll('[data-yf-size]').forEach(function (x) { x.classList.remove('is-selected'); });
        b.classList.add('is-selected'); st.size = +b.dataset.yfSize; doneEl.hidden = true; st.meldungen = []; render(); return;
      }
      var sw = e.target.closest('[data-yf-variant]');
      if (sw) {
        var slot = sw.closest('[data-yf-slot]');
        slot.querySelectorAll('.yf-set__swatch').forEach(function (x) { x.classList.remove('is-selected'); });
        sw.classList.add('is-selected'); doneEl.hidden = true; st.meldungen = []; render(); return;
      }
      var q = e.target.closest('[data-yf-qty]');
      if (q) { st.qty = Math.max(1, Math.min(20, st.qty + (+q.dataset.yfQty))); doneEl.hidden = true; st.meldungen = []; render(); return; }
      if (e.target.closest('[data-yf-add]')) { add(); }
    });
    if (anl) anl.addEventListener('change', function () { if (st.busy) { anl.checked = !anl.checked; return; } doneEl.hidden = true; st.meldungen = []; render(); });

    function zeilenText(items) {
      return items.map(function (i) { return i.quantity + ' × ' + i.product_title + (i.variant_title ? ', ' + i.variant_title : ''); }).join('; ');
    }

    /* Offener Vorgang: ein Hinzufuegen, dessen Ausgang noch nicht im Warenkorb bestaetigt ist.
       Liegt in sessionStorage, damit auch ein Neuladen der Seite ihn zuerst klaert statt doppelt zu legen. */
    var offenKey = 'yf-set-offen-' + root.dataset.setId;
    function offenSetzen(v) {
      st.offen = v;
      try { if (v) sessionStorage.setItem(offenKey, JSON.stringify(v)); else sessionStorage.removeItem(offenKey); } catch (e) {}
    }
    try { st.offen = JSON.parse(sessionStorage.getItem(offenKey) || 'null'); } catch (e) { st.offen = null; }

    function meineZeilen(cart, bundleId) {
      return (cart.items || []).filter(function (i) { return i.properties && i.properties._bundle_id === bundleId; });
    }
    function istVollstaendig(meine, items) {
      return meine.length === items.length && items.every(function (it) {
        return meine.some(function (i) { return i.variant_id === it.id && i.quantity === it.quantity; });
      });
    }
    function meld(text) {
      st.meldungen.push(text); render();
    }
    function drawerNeu(oeffnen) {
      if (!document.querySelector('cart-drawer')) return;
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      if (oeffnen) document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
    }
    function erfolg(meine, vorsatz) {
      offenSetzen(null);
      doneEl.textContent = (vorsatz || 'Im Warenkorb: ') + zeilenText(meine) + '.';
      doneEl.hidden = false;
      drawerNeu(true);
    }

    /* Entfernt die eigenen Zeilen eines Vorgangs und liest danach den Warenkorb neu.
       Liefert die Zeilen, die trotzdem noch drin sind (leer = sauber entfernt). */
    function bereinigen(meine, bundleId) {
      return meine.reduce(function (p, i) { return p.then(function () { return removeLine(i.key); }); }, Promise.resolve())
        .then(function () { return leseKorb(3); })
        .then(function (cart) { return meineZeilen(cart, bundleId); });
    }
    function restMelden(rest) {
      meld('Einige Teile dieses Sets konnten nicht wieder entfernt werden: ' + zeilenText(rest) + '. Bitte entferne sie im Warenkorb. Ein neuer Klick auf „In den Warenkorb“ prüft zuerst diesen Versuch und legt nichts doppelt hinein.');
      drawerNeu(false);
    }

    /* Klaert einen offenen Vorgang anhand seiner Vorgangskennung. true = erledigt, nichts Neues hinzufuegen. */
    function klaeren(v) {
      return leseKorb(3).then(function (cart) {
        var meine = meineZeilen(cart, v.bundleId);
        if (!meine.length) { offenSetzen(null); return false; }
        if (istVollstaendig(meine, v.items)) { erfolg(meine, 'Dieses Set aus deinem letzten Versuch liegt schon im Warenkorb: '); return true; }
        return bereinigen(meine, v.bundleId).then(function (rest) {
          if (rest.length) { restMelden(rest); return true; }
          offenSetzen(null);
          drawerNeu(false);
          meld('Vom letzten Versuch lag nur ein Teil des Sets im Warenkorb, dieser Teil wurde entfernt. Bitte klicke noch einmal auf „In den Warenkorb“.');
          return true;
        });
      });
    }

    function neuHinzufuegen() {
      var bundleId = root.dataset.setId + '-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      var qty = st.qty, sizeLabel = sizeName(), mitAnleitung = !!(anl && anl.checked);
      return leseKorb(2).then(function (c) {
        merkeKorb(c);
        if (!render()) { throw new Error('__stop'); }
        var b = bedarf(), items = [];
        var common = { 'Set': root.dataset.setTitle, '_bundle_id': bundleId, '_bundle_qty': String(qty) };
        if (groessen.length > 1) common['Größe'] = sizeLabel;
        b.order.forEach(function (id) {
          var v = b.byId[id], p = {};
          for (var k in common) p[k] = common[k];
          p['_bundle_teil'] = v.teile.join(', '); p['_bundle_unit_qty'] = String(v.n);
          items.push({ id: +id, quantity: v.n * qty, properties: p });
        });
        if (mitAnleitung) {
          var pa = {}; for (var k2 in common) pa[k2] = common[k2];
          pa['_bundle_teil'] = 'Anleitung'; pa['_bundle_unit_qty'] = '1';
          items.push({ id: +anl.dataset.id, quantity: 1, properties: pa });
        }
        /* Ab hier ist der Ausgang offen, bis der Warenkorb ihn bestaetigt. */
        var soll = items.map(function (i) { return { id: i.id, quantity: i.quantity }; });
        offenSetzen({ bundleId: bundleId, items: soll });
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: r.ok, body: null }; });
        }, function () { return { ok: false, body: null, netz: true }; }).then(function (res) {
          /* Massgeblich ist allein der tatsaechliche Warenkorb, nicht die Antwort auf das Hinzufuegen. */
          return leseKorb(3).then(function (cart) {
            var meine = meineZeilen(cart, bundleId);
            if (meine.length && istVollstaendig(meine, soll)) { erfolg(meine); return; }
            var grund = res.netz ? 'die Verbindung ist abgebrochen'
              : ((res.body && (res.body.description || res.body.message)) || 'Shopify hat die Anfrage abgelehnt');
            if (!meine.length) {
              offenSetzen(null);
              meld('Das Set wurde nicht in den Warenkorb gelegt (' + grund + '). Es wurde nichts hinzugefügt. Bitte prüfe Farben und Bestand und versuche es noch einmal.');
              return;
            }
            return bereinigen(meine, bundleId).then(function (rest) {
              if (rest.length) { restMelden(rest); return; }
              offenSetzen(null);
              drawerNeu(false);
              meld('Das Set wurde nicht in den Warenkorb gelegt (' + grund + '). Unvollständig hinzugefügte Teile wurden wieder entfernt. Bitte prüfe Farben und Bestand und versuche es noch einmal.');
            });
          });
        });
      });
    }

    function add() {
      if (st.busy) return;
      st.busy = true; doneEl.hidden = true; st.meldungen = []; render();
      (st.offen ? klaeren(st.offen) : Promise.resolve(false)).then(function (erledigt) {
        if (!erledigt) return neuHinzufuegen();
      }).catch(function (err) {
        if (err && err.message === '__stop') return;
        if (st.offen) {
          /* Warenkorb nicht lesbar, Ausgang unbekannt: nicht blind zum Wiederholen auffordern. */
          meld('Wir konnten gerade nicht prüfen, ob das Set im Warenkorb liegt. Bitte schau zuerst in den Warenkorb. Ein neuer Klick auf „In den Warenkorb“ prüft zuerst diesen Versuch und legt nichts doppelt hinein.');
        } else {
          meld('Der Warenkorb ist gerade nicht erreichbar. Es wurde nichts hinzugefügt. Bitte versuche es gleich noch einmal.');
        }
      }).then(function () {
        return refreshCart();
      }).then(function () {
        st.busy = false;
        render();
      });
    }

    document.addEventListener('on:cart:after-merge', function () { if (!st.busy) refreshCart().then(render); });
    refreshCart().then(render);
  }
  function run() { document.querySelectorAll('[data-yf-set]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
